export default {
  strict: true,
  namespaced: true,
  state: {
    admin: {
      list: []
    }
  },
  mutations: {
    setAdmin (state, value) {
      state.admin.list = value
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/provider/admin.js